export const USAGE_TYPE = {
    data: 'DATA',
    filter: 'FILTER',
    template: 'TEMPLATE'
}